import React from 'react';

const Payment = () => {
    return (
        <section></section>
    );
};

export default Payment;